import { cn } from "@/lib/utils";
import { ChevronDown, ChevronRight } from "lucide-react";

interface ErrorHeaderProps {
  message?: string;
  isExpanded: boolean;
  setIsExpanded?: () => void;
}

export function ErrorHeader({
  message = "An error occurred",
  isExpanded,
  setIsExpanded,
}: ErrorHeaderProps) {
  return (
    <div
      onClick={setIsExpanded}
      className={cn(
        "cursor-pointer flex w-full items-start gap-1 p-2 text-secondary-n-50",
      )}
    >
      {!setIsExpanded ? null : isExpanded ? (
        <ChevronDown className="h-4 w-4 text-secondary-n-500 shrink-0 mt-0.5" />
      ) : (
        <ChevronRight className="h-4 w-4 text-secondary-n-500 shrink-0 mt-0.5" />
      )}
      <div
        className={cn(
          "text-secondary-n-50 text-2xs flex-1",
          !isExpanded && "truncate",
        )}
      >
        {isExpanded
          ? message?.length > 500
            ? message.slice(0, 500) + "..."
            : message
          : message}
      </div>
    </div>
  );
}

export default ErrorHeader;
